(function () {
  'use strict';

  /* Avoid duplicate global listeners if Shopify reloads the product section. */
  if (window.MuralWonderCropper && typeof window.MuralWonderCropper.init === 'function') {
    window.MuralWonderCropper.init(document);
    return;
  }

  var UNIT_TO_CM = {
    cm: 1,
    in: 2.54,
    ft: 30.48
  };

  var QUALITY_WARNING_ZOOM = 1.5;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function round(value, decimals) {
    var factor = Math.pow(10, decimals || 0);
    return Math.round(value * factor) / factor;
  }

  function formatNumber(value, decimals) {
    var rounded = round(value, typeof decimals === 'number' ? decimals : 2);
    return String(rounded).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
  }

  function ratiosMatch(a, b) {
    if (!a || !b) return false;
    return Math.abs(a - b) / Math.max(Math.abs(a), Math.abs(b), 1) < 0.001;
  }

  function formatMoneyGBP(value) {
    if (!isFinite(value)) return '—';
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '£' + Number(value).toFixed(2);
    }
  }

  function normalizeMaterial(value) {
    var text = String(value || '').toLowerCase().replace(/&amp;/g, '&').trim();
    if (text.indexOf('washable') !== -1) return 'Washable';
    if (text.indexOf('peel') !== -1) return 'Peel & Stick';
    return 'Premium';
  }

  function MuralCropper(root) {
    if (!root || root.dataset.muralCropperReady === 'true') return;
    root.dataset.muralCropperReady = 'true';
    root._mwCropperInstance = this;

    this.root = root;
    this.widthInput = root.querySelector('[data-mw-width]');
    this.heightInput = root.querySelector('[data-mw-height]');
    this.unitSelect = root.querySelector('[data-mw-unit]');
    this.applyButton = root.querySelector('[data-mw-apply]');
    this.message = root.querySelector('[data-mw-message]');
    this.editor = root.querySelector('[data-mw-editor]');
    this.summary = root.querySelector('[data-mw-summary]');
    this.readyBadge = root.querySelector('[data-mw-ready-badge]');
    this.stage = root.querySelector('[data-mw-stage]');
    this.stageWrap = this.stage ? this.stage.parentElement : null;
    this.image = root.querySelector('[data-mw-image]');
    this.zoomInput = root.querySelector('[data-mw-zoom]');
    this.zoomOutput = root.querySelector('[data-mw-zoom-output]');
    this.zoomOutButton = root.querySelector('[data-mw-zoom-out]');
    this.zoomInButton = root.querySelector('[data-mw-zoom-in]');
    this.centerButton = root.querySelector('[data-mw-center]');
    this.rotateButton = root.querySelector('[data-mw-rotate]');
    this.mirrorButton = root.querySelector('[data-mw-mirror]');
    this.resetButton = root.querySelector('[data-mw-reset]');
    this.dragHint = root.querySelector('[data-mw-drag-hint]');
    this.quality = root.querySelector('[data-mw-quality]');
    this.confirmButton = root.querySelector('[data-mw-confirm]');
    this.confirmNote = root.querySelector('[data-mw-confirm-note]');
    this.addToCartButton = null;
    this.priceLabel = root.querySelector('[data-mw-price-label]');
    this.priceArea = root.querySelector('[data-mw-price-area]');
    this.totalOutput = root.querySelector('[data-mw-total]');
    this.rateCards = Array.prototype.slice.call(root.querySelectorAll('[data-mw-rate-card]'));
    this.propertySize = root.querySelector('[data-mw-property-size]');
    this.propertyArea = root.querySelector('[data-mw-property-area]');
    this.propertyRate = root.querySelector('[data-mw-property-rate]');
    this.propertyPrice = root.querySelector('[data-mw-property-price]');
    this.propertyCrop = root.querySelector('[data-mw-property-crop]');
    this.propertyData = root.querySelector('[data-mw-property-data]');
    this.propertyPricing = root.querySelector('[data-mw-property-pricing]');
    this.propertyPreview = root.querySelector('[data-mw-property-preview]');
    this.form = root.closest('form[action*="/cart/add"]') || root.closest('form');
    this.productScope = root.closest('.c67-product2__panel') || document;
    this.formId = root.dataset.formId || (this.form ? this.form.id : '');
    this.imageLabel = root.dataset.imageLabel || 'Image 2';
    this.imageId = root.dataset.imageId || '';
    this.rates = {
      'Premium': Number(root.dataset.ratePremium) || 27,
      'Washable': Number(root.dataset.rateWashable) || 35,
      'Peel & Stick': Number(root.dataset.ratePeelStick) || 37
    };
    this.minimums = {
      'Premium': Number(root.dataset.minimumPremium) || 30,
      'Washable': Number(root.dataset.minimumWashable) || 40,
      'Peel & Stick': Number(root.dataset.minimumPeelStick) || 40
    };

    this.state = {
      unit: this.unitSelect ? this.unitSelect.value : 'cm',
      width: 0,
      height: 0,
      widthCm: 0,
      heightCm: 0,
      ratio: 1,
      zoom: 1,
      rotation: 0,
      mirrored: false,
      offsetX: 0,
      offsetY: 0,
      naturalWidth: Number(root.dataset.imageWidth) || 0,
      naturalHeight: Number(root.dataset.imageHeight) || 0,
      stageWidth: 0,
      stageHeight: 0,
      material: 'Premium',
      rate: 27,
      minimum: 30,
      areaM2: 0,
      calculatedPrice: 0,
      ready: false,
      dirty: false,
      confirmed: false
    };

    this.pointer = null;
    this.resizeObserver = null;
    this.propertyRaf = null;
    this.windowResizeHandler = null;
    this.materialChangeHandler = null;
    this.variantChangeHandler = null;

    if (this.form) {
      this.form.enctype = 'multipart/form-data';
      this.form.classList.add('mw-cropper-pending');
      this.addToCartButton = this.form.querySelector('[data-add-to-cart], button[name=\"add\"]');
    }
    this.setOrderLocked(true);

    this.updateMaterialFromPage();
    this.updatePriceFromInputs();
    this.bindEvents();
    this.loadImageDimensions();
  }

  MuralCropper.prototype.bindEvents = function () {
    var self = this;

    this.applyButton.addEventListener('click', function () {
      self.applyDimensions();
    });

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', function () {
        self.confirmCrop();
      });
    }

    [this.widthInput, this.heightInput].forEach(function (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.applyDimensions();
        }
      });

      input.addEventListener('input', function () {
        /*
          A manual dimension edit becomes the new source of truth. Any exact
          centimetre value cached during a display-unit switch must therefore
          be discarded before live pricing is recalculated.
        */
        delete self.widthInput.dataset.mwCanonicalCm;
        delete self.heightInput.dataset.mwCanonicalCm;
        self.markDimensionsDirty();
        self.updatePriceFromInputs();
      });
    });

    this.unitSelect.addEventListener('change', function () {
      var nextUnit = self.unitSelect.value;
      var previousUnit = self.state.unit;
      self.convertDisplayedUnits(previousUnit, nextUnit);
      self.state.unit = nextUnit;

      if (self.state.ready && previousUnit !== nextUnit) {
        self.invalidateConfirmation('unit');
      }

      if (self.state.ready && !self.state.dirty) {
        self.state.width = parseFloat(self.widthInput.value);
        self.state.height = parseFloat(self.heightInput.value);
        self.updateSummary();
        self.schedulePropertiesUpdate();
      }
      self.updatePriceFromInputs();
    });

    this.materialChangeHandler = function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var wrap = target.closest('.variant-input-wrap');
      if (!wrap || String(wrap.dataset.handle || '').toLowerCase().indexOf('material') === -1) return;
      if (self.formId) {
        var targetForm = target.getAttribute('form') || (target.form && target.form.id) || '';
        if (targetForm && targetForm !== self.formId) return;
      }
      self.updateMaterialFromPage();
    };
    document.addEventListener('change', this.materialChangeHandler);

    this.variantChangeHandler = function () {
      window.requestAnimationFrame(function () { self.updateMaterialFromPage(); });
    };
    document.addEventListener('variant:change', this.variantChangeHandler);

    this.zoomInput.addEventListener('input', function () {
      self.setZoom(Number(self.zoomInput.value));
    });

    this.zoomOutButton.addEventListener('click', function () {
      self.setZoom(Number(self.zoomInput.value) - 10);
    });

    this.zoomInButton.addEventListener('click', function () {
      self.setZoom(Number(self.zoomInput.value) + 10);
    });

    this.centerButton.addEventListener('click', function () {
      if (!self.canEditCrop()) return;
      self.invalidateConfirmation('crop');
      self.state.offsetX = 0;
      self.state.offsetY = 0;
      self.hideDragHint();
      self.render();
      self.updateProperties();
    });

    this.rotateButton.addEventListener('click', function () {
      if (!self.canEditCrop()) return;
      self.invalidateConfirmation('crop');
      self.state.rotation = (self.state.rotation + 90) % 360;
      self.state.offsetX = 0;
      self.state.offsetY = 0;
      self.hideDragHint();
      self.render();
      self.updateProperties();
    });

    this.mirrorButton.addEventListener('click', function () {
      if (!self.canEditCrop()) return;
      self.invalidateConfirmation('crop');
      self.state.mirrored = !self.state.mirrored;
      self.mirrorButton.setAttribute('aria-pressed', self.state.mirrored ? 'true' : 'false');
      self.hideDragHint();
      self.render();
      self.updateProperties();
    });

    this.resetButton.addEventListener('click', function () {
      if (!self.canEditCrop()) return;
      self.resetCrop();
    });

    this.stage.addEventListener('pointerdown', function (event) {
      if (!self.canEditCrop() || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault();
      self.invalidateConfirmation('crop');
      self.pointer = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        startX: self.state.offsetX,
        startY: self.state.offsetY
      };
      if (self.stage.setPointerCapture) self.stage.setPointerCapture(event.pointerId);
      self.stage.classList.add('is-dragging');
      self.hideDragHint();
    });

    this.stage.addEventListener('pointermove', function (event) {
      if (!self.pointer || self.pointer.id !== event.pointerId) return;
      self.state.offsetX = self.pointer.startX + (event.clientX - self.pointer.x);
      self.state.offsetY = self.pointer.startY + (event.clientY - self.pointer.y);
      self.render();
      self.schedulePropertiesUpdate();
    });

    function endPointer(event) {
      if (!self.pointer || self.pointer.id !== event.pointerId) return;
      self.pointer = null;
      self.stage.classList.remove('is-dragging');
      self.updateProperties();
    }

    this.stage.addEventListener('pointerup', endPointer);
    this.stage.addEventListener('pointercancel', endPointer);

    this.stage.addEventListener('keydown', function (event) {
      if (!self.canEditCrop()) return;
      var amount = event.shiftKey ? 10 : 2;
      var handled = true;

      if (event.key === 'ArrowLeft') self.state.offsetX -= amount;
      else if (event.key === 'ArrowRight') self.state.offsetX += amount;
      else if (event.key === 'ArrowUp') self.state.offsetY -= amount;
      else if (event.key === 'ArrowDown') self.state.offsetY += amount;
      else handled = false;

      if (handled) {
        event.preventDefault();
        self.invalidateConfirmation('crop');
        self.hideDragHint();
        self.render();
        self.schedulePropertiesUpdate();
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        if (self.state.ready && !self.state.dirty && self.state.confirmed) {
          self.updateProperties();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        var submitMessage = 'Please enter your wall size and set the crop before adding this mural to your cart.';
        if (self.state.dirty) {
          submitMessage = 'Your wall size changed. Please update and confirm the crop before adding this mural to your cart.';
        } else if (self.state.ready && !self.state.confirmed) {
          submitMessage = 'Please review the crop preview and click Confirm crop before adding this mural to your cart.';
        }

        self.setMessage(submitMessage, 'error');
        if (!self.state.ready || self.state.dirty) self.widthInput.focus();
        else if (self.confirmButton) self.confirmButton.focus();
        if (self.root.scrollIntoView) {
          self.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    this.windowResizeHandler = function () {
      if (self.state.ready && !self.state.dirty) {
        self.fitStageToViewport();
        self.render();
        self.schedulePropertiesUpdate();
      }
    };
    window.addEventListener('resize', this.windowResizeHandler);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.windowResizeHandler);
    }

    if ('ResizeObserver' in window && this.stageWrap) {
      this.resizeObserver = new ResizeObserver(function () {
        if (self.state.ready && !self.state.dirty) {
          self.fitStageToViewport();
          self.render();
          self.schedulePropertiesUpdate();
        }
      });
      this.resizeObserver.observe(this.stageWrap);
    }
  };

  MuralCropper.prototype.getSelectedMaterial = function () {
    var scope = this.productScope || document;
    var wrappers = scope.querySelectorAll('.variant-input-wrap');

    for (var i = 0; i < wrappers.length; i += 1) {
      var wrapper = wrappers[i];
      if (String(wrapper.dataset.handle || '').toLowerCase().indexOf('material') === -1) continue;

      var checked = wrapper.querySelector('input[data-variant-input]:checked');
      if (checked) {
        if (!this.formId || checked.getAttribute('form') === this.formId) return normalizeMaterial(checked.value);
      }

      var select = wrapper.querySelector('select[data-variant-input]');
      if (select) {
        if (!this.formId || select.getAttribute('form') === this.formId) return normalizeMaterial(select.value);
      }
    }

    return this.state && this.state.material ? this.state.material : 'Premium';
  };

  MuralCropper.prototype.updateMaterialFromPage = function () {
    var material = this.getSelectedMaterial();
    var rate = this.rates[material] || this.rates.Premium || 27;
    var minimum = this.minimums[material] || this.minimums.Premium || 30;

    this.state.material = material;
    this.state.rate = rate;
    this.state.minimum = minimum;

    if (this.priceLabel) this.priceLabel.textContent = material + ' · £' + formatNumber(rate, 2) + ' / m²';

    this.rateCards.forEach(function (card) {
      var key = String(card.dataset.mwRateCard || '');
      var active = (material === 'Premium' && key === 'premium') ||
        (material === 'Washable' && key === 'washable') ||
        (material === 'Peel & Stick' && key === 'peel-stick');
      card.classList.toggle('is-active', active);
    });

    this.updatePriceFromInputs();
    if (this.state.ready && !this.state.dirty) this.schedulePropertiesUpdate();
  };

  MuralCropper.prototype.getInputAreaM2 = function () {
    /*
      A unit selector is a display choice, not a size edit. Preserve an exact
      centimetre source value while cm/in/ft are being switched so rounded
      imperial display values (for example 6.562 ft) cannot change the area or
      price. This also works before the customer has opened the composition.
      A manual width/height edit clears the cached values in bindEvents().
    */
    var cachedWidthCm = parseFloat(this.widthInput.dataset.mwCanonicalCm || '');
    var cachedHeightCm = parseFloat(this.heightInput.dataset.mwCanonicalCm || '');
    if (isFinite(cachedWidthCm) && cachedWidthCm > 0 && isFinite(cachedHeightCm) && cachedHeightCm > 0) {
      return (cachedWidthCm * cachedHeightCm) / 10000;
    }

    if (this.state.ready && !this.state.dirty && this.state.widthCm > 0 && this.state.heightCm > 0) {
      return (this.state.widthCm * this.state.heightCm) / 10000;
    }

    var width = parseFloat(this.widthInput.value);
    var height = parseFloat(this.heightInput.value);
    var unit = this.unitSelect.value;
    if (!UNIT_TO_CM[unit] || !isFinite(width) || !isFinite(height) || width <= 0 || height <= 0) return 0;
    return ((width * UNIT_TO_CM[unit]) * (height * UNIT_TO_CM[unit])) / 10000;
  };

  MuralCropper.prototype.updatePriceFromInputs = function () {
    var areaM2 = this.getInputAreaM2();
    var rawTotal = areaM2 > 0 ? areaM2 * this.state.rate : 0;
    var total = areaM2 > 0 ? Math.max(rawTotal, this.state.minimum || 0) : 0;
    var minimumApplied = areaM2 > 0 && rawTotal < (this.state.minimum || 0);

    if (this.priceArea) {
      if (areaM2 <= 0) {
        this.priceArea.textContent = 'Enter your wall size to calculate the price';
      } else if (minimumApplied) {
        this.priceArea.textContent = formatNumber(areaM2, 2) + ' m² · minimum mural price applies';
      } else {
        this.priceArea.textContent = formatNumber(areaM2, 2) + ' m² × £' + formatNumber(this.state.rate, 2) + ' / m²';
      }
    }
    if (this.totalOutput) this.totalOutput.textContent = areaM2 > 0 ? formatMoneyGBP(total) : '—';
  };

  MuralCropper.prototype.loadImageDimensions = function () {
    var self = this;

    function setDimensions() {
      if (!self.state.naturalWidth) self.state.naturalWidth = self.image.naturalWidth || 1;
      if (!self.state.naturalHeight) self.state.naturalHeight = self.image.naturalHeight || 1;
      if (self.state.ready && !self.state.dirty) {
        self.fitStageToViewport();
        self.render();
        self.updateProperties();
      }
    }

    if (this.image.complete && this.image.naturalWidth) {
      setDimensions();
    } else {
      this.image.addEventListener('load', setDimensions, { once: true });
      this.image.addEventListener('error', function () {
        self.setMessage('The mural design image could not be loaded. Please refresh the page.', 'error');
      }, { once: true });
    }
  };

  MuralCropper.prototype.convertDisplayedUnits = function (fromUnit, toUnit) {
    if (!UNIT_TO_CM[fromUnit] || !UNIT_TO_CM[toUnit] || fromUnit === toUnit) return;

    /*
      Preserve the physical dimensions independently from their rounded
      display values. The first unit switch captures the exact current size in
      centimetres; subsequent unit switches reuse that exact value. This works
      both before and after the composition has been opened.
    */
    var widthCm = parseFloat(this.widthInput.dataset.mwCanonicalCm || '');
    var heightCm = parseFloat(this.heightInput.dataset.mwCanonicalCm || '');

    if (!(isFinite(widthCm) && widthCm > 0 && isFinite(heightCm) && heightCm > 0)) {
      if (this.state.ready && !this.state.dirty && this.state.widthCm > 0 && this.state.heightCm > 0) {
        widthCm = this.state.widthCm;
        heightCm = this.state.heightCm;
      } else {
        var width = parseFloat(this.widthInput.value);
        var height = parseFloat(this.heightInput.value);
        if (!isFinite(width) || width <= 0 || !isFinite(height) || height <= 0) return;
        widthCm = width * UNIT_TO_CM[fromUnit];
        heightCm = height * UNIT_TO_CM[fromUnit];
      }
    }

    this.widthInput.dataset.mwCanonicalCm = String(widthCm);
    this.heightInput.dataset.mwCanonicalCm = String(heightCm);
    this.widthInput.value = round(widthCm / UNIT_TO_CM[toUnit], 3);
    this.heightInput.value = round(heightCm / UNIT_TO_CM[toUnit], 3);
  };

  MuralCropper.prototype.setOrderLocked = function (locked) {
    if (this.form) this.form.classList.toggle('mw-cropper-pending', !!locked);
    if (!this.addToCartButton) return;

    /*
      Do not set the native disabled property here. Third-party pricing apps
      such as Apippa may bind their signed Cart Transform handoff while the
      product form initialises, and a physically disabled submit control can
      prevent or disrupt that binding. The capture-phase submit gate below is
      the authoritative lock; aria/data state is only for UX and styling.
    */
    if (locked) {
      this.addToCartButton.setAttribute('aria-disabled', 'true');
      this.addToCartButton.dataset.mwCropLocked = 'true';
    } else if (this.addToCartButton.dataset.mwCropLocked === 'true') {
      this.addToCartButton.removeAttribute('aria-disabled');
      delete this.addToCartButton.dataset.mwCropLocked;
    }
  };

  MuralCropper.prototype.invalidateConfirmation = function (reason) {
    if (!this.state.confirmed) {
      this.setOrderLocked(true);
      return;
    }

    this.state.confirmed = false;
    this.setOrderLocked(true);
    this.clearProperties();
    if (this.readyBadge) this.readyBadge.textContent = 'Reconfirm crop';
    if (this.confirmButton) {
      this.confirmButton.disabled = false;
      this.confirmButton.textContent = 'Confirm crop';
    }
    if (this.confirmNote) this.confirmNote.textContent = 'The selection changed. Review the preview and confirm the crop again.';
    if (reason === 'crop') this.setMessage('Crop changed — confirm it again before adding to cart.', 'warning');
  };

  MuralCropper.prototype.confirmCrop = function () {
    var self = this;
    if (!this.state.ready || this.state.dirty) {
      this.setMessage('Please set your wall size before confirming the crop.', 'error');
      return;
    }

    var crop = this.getCropRect();
    if (!crop) {
      this.setMessage('The crop preview is not ready yet. Please try again.', 'error');
      return;
    }

    this.state.confirmed = true;
    this.updateProperties();
    this.setOrderLocked(true);
    if (this.confirmButton) {
      this.confirmButton.disabled = true;
      this.confirmButton.textContent = 'Preparing preview…';
    }
    if (this.confirmNote) this.confirmNote.textContent = 'Saving a visual reference of your approved crop.';
    this.setMessage('Preparing your approved crop preview…', '');

    this.prepareCropPreview(crop).catch(function () {
      /* The JPEG is a fulfilment convenience only; raw crop data remains authoritative. */
      self.clearCropPreviewFile();
    }).then(function () {
      if (!self.state.confirmed || self.state.dirty) return;
      self.setOrderLocked(false);
      if (self.readyBadge) self.readyBadge.textContent = 'Crop confirmed';
      if (self.confirmButton) {
        self.confirmButton.disabled = true;
        self.confirmButton.textContent = 'Crop confirmed ✓';
      }
      if (self.confirmNote) self.confirmNote.textContent = 'Your crop is confirmed. Add to Cart is now enabled.';
      self.setMessage('Crop confirmed. You can now add this mural to your cart.', '');
    });
  };

  MuralCropper.prototype.markDimensionsDirty = function () {
    if (!this.state.ready || this.state.dirty) return;

    this.invalidateConfirmation('size');
    this.state.dirty = true;
    this.root.classList.add('is-stale');
    this.setOrderLocked(true);
    if (this.readyBadge) this.readyBadge.textContent = 'Update required';
    this.applyButton.textContent = 'Update size & crop';
    this.clearProperties();
    this.setMessage('Size changed — update the crop before adding to cart.', 'warning');
  };

  MuralCropper.prototype.applyDimensions = function () {
    var width = parseFloat(this.widthInput.value);
    var height = parseFloat(this.heightInput.value);
    var unit = this.unitSelect.value;

    if (!UNIT_TO_CM[unit] || !isFinite(width) || !isFinite(height) || width <= 0 || height <= 0) {
      this.setMessage('Please enter a valid wall width and height.', 'error');
      return;
    }

    var newRatio = width / height;
    var preserveCrop = this.state.ready && ratiosMatch(this.state.ratio, newRatio);

    this.state.unit = unit;
    this.state.width = width;
    this.state.height = height;

    /*
      If the only change was the display unit, use the exact centimetre values
      cached by convertDisplayedUnits() rather than converting the rounded
      imperial text back into centimetres.
    */
    var cachedWidthCm = parseFloat(this.widthInput.dataset.mwCanonicalCm || '');
    var cachedHeightCm = parseFloat(this.heightInput.dataset.mwCanonicalCm || '');
    this.state.widthCm = (isFinite(cachedWidthCm) && cachedWidthCm > 0) ? cachedWidthCm : width * UNIT_TO_CM[unit];
    this.state.heightCm = (isFinite(cachedHeightCm) && cachedHeightCm > 0) ? cachedHeightCm : height * UNIT_TO_CM[unit];
    this.widthInput.dataset.mwCanonicalCm = String(this.state.widthCm);
    this.heightInput.dataset.mwCanonicalCm = String(this.state.heightCm);
    this.state.ratio = newRatio;
    this.state.areaM2 = (this.state.widthCm * this.state.heightCm) / 10000;
    this.state.calculatedPrice = Math.max(this.state.areaM2 * this.state.rate, this.state.minimum || 0);
    this.state.ready = true;
    this.state.dirty = false;
    this.state.confirmed = false;

    this.root.classList.remove('is-stale');
    this.setOrderLocked(true);
    if (this.readyBadge) this.readyBadge.textContent = 'Review crop';
    if (this.confirmButton) {
      this.confirmButton.disabled = false;
      this.confirmButton.textContent = 'Confirm crop';
    }
    if (this.confirmNote) this.confirmNote.textContent = 'Review the framed preview, then confirm the crop to enable Add to Cart.';
    this.applyButton.textContent = 'Update size & crop';

    this.editor.hidden = false;
    this.fitStageToViewport();
    this.setMessage('', '');
    this.updateSummary();
    this.updatePriceFromInputs();

    if (!preserveCrop) {
      this.resetCrop();
    } else {
      var self = this;
      window.requestAnimationFrame(function () {
        self.render();
        self.updateProperties();
      });
    }
  };

  MuralCropper.prototype.fitStageToViewport = function () {
    if (!this.stage || !this.state.ratio || !isFinite(this.state.ratio) || this.state.ratio <= 0) return;

    var wrapWidth = this.stageWrap ? this.stageWrap.clientWidth : this.root.clientWidth;
    if (!wrapWidth) return;

    var viewportHeight = window.visualViewport && window.visualViewport.height
      ? window.visualViewport.height
      : window.innerHeight;

    /*
      Keep unusually tall murals fully visible. The preview is only a viewing
      surface; reducing its CSS size does not change the crop ratio or saved
      production coordinates.
    */
    var maxStageHeight = Math.min(640, Math.max(280, viewportHeight * 0.62));
    var stageWidth = wrapWidth;
    var stageHeight = stageWidth / this.state.ratio;

    if (stageHeight > maxStageHeight) {
      stageHeight = maxStageHeight;
      stageWidth = stageHeight * this.state.ratio;
    }

    if (stageWidth > wrapWidth) {
      stageWidth = wrapWidth;
      stageHeight = stageWidth / this.state.ratio;
    }

    this.stage.style.width = Math.max(1, Math.round(stageWidth * 100) / 100) + 'px';
    this.stage.style.height = Math.max(1, Math.round(stageHeight * 100) / 100) + 'px';
    this.stage.style.aspectRatio = this.state.width + ' / ' + this.state.height;
  };

  MuralCropper.prototype.canEditCrop = function () {
    return this.state.ready && !this.state.dirty;
  };

  MuralCropper.prototype.setZoom = function (percent) {
    if (!this.canEditCrop()) return;
    percent = clamp(Math.round(percent), 100, 300);
    this.invalidateConfirmation('crop');
    this.state.zoom = percent / 100;
    this.zoomInput.value = String(percent);
    this.zoomOutput.textContent = percent + '%';
    this.hideDragHint();
    this.render();
    this.schedulePropertiesUpdate();
  };

  MuralCropper.prototype.resetCrop = function () {
    if (this.state.confirmed) this.invalidateConfirmation('crop');
    this.state.zoom = 1;
    this.state.rotation = 0;
    this.state.mirrored = false;
    this.state.offsetX = 0;
    this.state.offsetY = 0;
    this.state.stageWidth = 0;
    this.state.stageHeight = 0;
    this.zoomInput.value = '100';
    this.zoomOutput.textContent = '100%';
    this.mirrorButton.setAttribute('aria-pressed', 'false');
    if (this.dragHint) this.dragHint.classList.remove('is-hidden');

    var self = this;
    window.requestAnimationFrame(function () {
      self.fitStageToViewport();
      self.render();
      self.updateProperties();
    });
  };

  MuralCropper.prototype.hideDragHint = function () {
    if (this.dragHint) this.dragHint.classList.add('is-hidden');
  };

  MuralCropper.prototype.updateSummary = function () {
    this.state.areaM2 = (this.state.widthCm * this.state.heightCm) / 10000;
    this.state.calculatedPrice = Math.max(this.state.areaM2 * this.state.rate, this.state.minimum || 0);
    this.summary.textContent =
      'Preview for ' + formatNumber(this.state.width, 3) + ' × ' + formatNumber(this.state.height, 3) + ' ' + this.state.unit +
      ' • ' + formatNumber(this.state.areaM2, 2) + ' m²' +
      ' • ' + this.state.material + ' ' + formatMoneyGBP(this.state.calculatedPrice);
    this.updatePriceFromInputs();
  };

  MuralCropper.prototype.getRenderMetrics = function () {
    var stageWidth = this.stage.clientWidth;
    var stageHeight = this.stage.clientHeight;
    var naturalWidth = this.state.naturalWidth || this.image.naturalWidth || 1;
    var naturalHeight = this.state.naturalHeight || this.image.naturalHeight || 1;
    var quarterTurn = this.state.rotation % 180 !== 0;
    var rotatedNaturalWidth = quarterTurn ? naturalHeight : naturalWidth;
    var rotatedNaturalHeight = quarterTurn ? naturalWidth : naturalHeight;
    var baseScale = Math.max(stageWidth / rotatedNaturalWidth, stageHeight / rotatedNaturalHeight);
    var scale = baseScale * this.state.zoom;
    var renderedWidth = rotatedNaturalWidth * scale;
    var renderedHeight = rotatedNaturalHeight * scale;
    var maxOffsetX = Math.max(0, (renderedWidth - stageWidth) / 2);
    var maxOffsetY = Math.max(0, (renderedHeight - stageHeight) / 2);

    return {
      stageWidth: stageWidth,
      stageHeight: stageHeight,
      naturalWidth: naturalWidth,
      naturalHeight: naturalHeight,
      rotatedNaturalWidth: rotatedNaturalWidth,
      rotatedNaturalHeight: rotatedNaturalHeight,
      scale: scale,
      renderedWidth: renderedWidth,
      renderedHeight: renderedHeight,
      maxOffsetX: maxOffsetX,
      maxOffsetY: maxOffsetY
    };
  };

  MuralCropper.prototype.render = function () {
    if (!this.state.ready || !this.stage.clientWidth || !this.stage.clientHeight) return;

    var metrics = this.getRenderMetrics();

    if (this.state.stageWidth > 0 && this.state.stageHeight > 0 &&
        (this.state.stageWidth !== metrics.stageWidth || this.state.stageHeight !== metrics.stageHeight)) {
      this.state.offsetX = this.state.offsetX * (metrics.stageWidth / this.state.stageWidth);
      this.state.offsetY = this.state.offsetY * (metrics.stageHeight / this.state.stageHeight);
    }
    this.state.stageWidth = metrics.stageWidth;
    this.state.stageHeight = metrics.stageHeight;

    this.state.offsetX = clamp(this.state.offsetX, -metrics.maxOffsetX, metrics.maxOffsetX);
    this.state.offsetY = clamp(this.state.offsetY, -metrics.maxOffsetY, metrics.maxOffsetY);

    var unrotatedWidth = metrics.naturalWidth * metrics.scale;
    var unrotatedHeight = metrics.naturalHeight * metrics.scale;

    this.image.style.width = unrotatedWidth + 'px';
    this.image.style.height = unrotatedHeight + 'px';
    this.image.style.left = 'calc(50% + ' + this.state.offsetX + 'px)';
    this.image.style.top = 'calc(50% + ' + this.state.offsetY + 'px)';
    this.image.style.transform =
      'translate(-50%, -50%) scaleX(' + (this.state.mirrored ? -1 : 1) + ') rotate(' + this.state.rotation + 'deg)';
  };

  /*
    Returns the exact crop rectangle in the transformed image coordinate space:
    rotate the source, apply the horizontal mirror if selected, then crop this rectangle.
  */
  MuralCropper.prototype.getCropRect = function () {
    var metrics = this.getRenderMetrics();
    if (!metrics.stageWidth || !metrics.stageHeight || !metrics.scale) return null;

    var offsetX = clamp(this.state.offsetX, -metrics.maxOffsetX, metrics.maxOffsetX);
    var offsetY = clamp(this.state.offsetY, -metrics.maxOffsetY, metrics.maxOffsetY);
    var x = ((metrics.renderedWidth - metrics.stageWidth) / 2 - offsetX) / metrics.scale;
    var y = ((metrics.renderedHeight - metrics.stageHeight) / 2 - offsetY) / metrics.scale;
    var width = metrics.stageWidth / metrics.scale;
    var height = metrics.stageHeight / metrics.scale;

    x = clamp(x, 0, Math.max(0, metrics.rotatedNaturalWidth - width));
    y = clamp(y, 0, Math.max(0, metrics.rotatedNaturalHeight - height));
    width = Math.min(width, metrics.rotatedNaturalWidth);
    height = Math.min(height, metrics.rotatedNaturalHeight);

    return {
      x: x,
      y: y,
      width: width,
      height: height,
      imageWidth: metrics.rotatedNaturalWidth,
      imageHeight: metrics.rotatedNaturalHeight,
      xPct: metrics.rotatedNaturalWidth ? (x / metrics.rotatedNaturalWidth) * 100 : 0,
      yPct: metrics.rotatedNaturalHeight ? (y / metrics.rotatedNaturalHeight) * 100 : 0,
      widthPct: metrics.rotatedNaturalWidth ? (width / metrics.rotatedNaturalWidth) * 100 : 100,
      heightPct: metrics.rotatedNaturalHeight ? (height / metrics.rotatedNaturalHeight) * 100 : 100
    };
  };

  MuralCropper.prototype.updateQualityWarning = function (crop) {
    if (!this.quality || !crop) return;

    if (this.state.zoom >= QUALITY_WARNING_ZOOM) {
      this.quality.hidden = false;
      this.quality.textContent = 'This crop is significantly zoomed in. For the best print detail, consider using a wider crop.';
    } else {
      this.quality.hidden = true;
      this.quality.textContent = '';
    }
  };

  MuralCropper.prototype.schedulePropertiesUpdate = function () {
    var self = this;
    if (this.propertyRaf) return;
    this.propertyRaf = window.requestAnimationFrame(function () {
      self.propertyRaf = null;
      self.updateProperties();
    });
  };

  MuralCropper.prototype.clearCropPreviewFile = function () {
    if (!this.propertyPreview) return;
    try { this.propertyPreview.value = ''; } catch (error) { /* no-op */ }
  };

  MuralCropper.prototype.prepareCropPreview = function (crop) {
    var self = this;
    if (!this.propertyPreview || !crop || !this.image || !this.image.complete || !this.image.naturalWidth) {
      return Promise.resolve(false);
    }
    if (typeof window.DataTransfer !== 'function' || typeof window.File !== 'function') {
      return Promise.reject(new Error('Browser file attachment is unavailable.'));
    }

    return new Promise(function (resolve, reject) {
      try {
        var sourceWidth = self.image.naturalWidth || 1;
        var sourceHeight = self.image.naturalHeight || 1;
        var quarterTurn = self.state.rotation % 180 !== 0;
        var transformedWidth = quarterTurn ? sourceHeight : sourceWidth;
        var transformedHeight = quarterTurn ? sourceWidth : sourceHeight;

        var transformed = document.createElement('canvas');
        transformed.width = transformedWidth;
        transformed.height = transformedHeight;
        var tctx = transformed.getContext('2d');
        if (!tctx) throw new Error('Canvas is unavailable.');

        tctx.save();
        tctx.translate(transformedWidth / 2, transformedHeight / 2);
        if (self.state.mirrored) tctx.scale(-1, 1);
        tctx.rotate((self.state.rotation * Math.PI) / 180);
        tctx.drawImage(self.image, -sourceWidth / 2, -sourceHeight / 2, sourceWidth, sourceHeight);
        tctx.restore();

        var scaleX = transformedWidth / Math.max(crop.imageWidth || transformedWidth, 1);
        var scaleY = transformedHeight / Math.max(crop.imageHeight || transformedHeight, 1);
        var sx = clamp(crop.x * scaleX, 0, transformedWidth);
        var sy = clamp(crop.y * scaleY, 0, transformedHeight);
        var sw = clamp(crop.width * scaleX, 1, transformedWidth - sx || 1);
        var sh = clamp(crop.height * scaleY, 1, transformedHeight - sy || 1);

        var maxEdge = 1400;
        var outputScale = Math.min(1, maxEdge / Math.max(sw, sh));
        var outputWidth = Math.max(1, Math.round(sw * outputScale));
        var outputHeight = Math.max(1, Math.round(sh * outputScale));
        var output = document.createElement('canvas');
        output.width = outputWidth;
        output.height = outputHeight;
        var octx = output.getContext('2d');
        if (!octx) throw new Error('Canvas is unavailable.');
        octx.drawImage(transformed, sx, sy, sw, sh, 0, 0, outputWidth, outputHeight);

        output.toBlob(function (blob) {
          if (!blob) {
            reject(new Error('Could not create crop preview.'));
            return;
          }
          try {
            var handle = String(self.root.dataset.productHandle || 'mural').replace(/[^a-z0-9_-]+/gi, '-');
            var filename = 'approved-crop-' + handle + '.jpg';
            var file = new File([blob], filename, { type: 'image/jpeg', lastModified: Date.now() });
            var transfer = new DataTransfer();
            transfer.items.add(file);
            self.propertyPreview.files = transfer.files;
            resolve(true);
          } catch (error) {
            reject(error);
          }
        }, 'image/jpeg', 0.86);
      } catch (error) {
        reject(error);
      }
    });
  };

  MuralCropper.prototype.clearProperties = function () {
    if (this.propertySize) this.propertySize.value = '';
    if (this.propertyArea) this.propertyArea.value = '';
    if (this.propertyRate) this.propertyRate.value = '';
    if (this.propertyPrice) this.propertyPrice.value = '';
    if (this.propertyCrop) this.propertyCrop.value = '';
    if (this.propertyData) this.propertyData.value = '';
    if (this.propertyPricing) this.propertyPricing.value = '';
    this.clearCropPreviewFile();
    if (this.quality) {
      this.quality.hidden = true;
      this.quality.textContent = '';
    }
  };

  MuralCropper.prototype.updateProperties = function () {
    if (!this.state.ready || this.state.dirty || !this.state.confirmed) {
      this.clearProperties();
      return;
    }

    var crop = this.getCropRect();
    if (!crop) return;

    var cmText = formatNumber(this.state.widthCm, 2) + ' × ' + formatNumber(this.state.heightCm, 2) + ' cm';
    var enteredText = formatNumber(this.state.width, 3) + ' × ' + formatNumber(this.state.height, 3) + ' ' + this.state.unit;
    this.state.areaM2 = (this.state.widthCm * this.state.heightCm) / 10000;
    this.state.calculatedPrice = Math.max(this.state.areaM2 * this.state.rate, this.state.minimum || 0);

    this.propertySize.value = this.state.unit === 'cm' ? cmText : enteredText + ' (' + cmText + ')';
    if (this.propertyArea) this.propertyArea.value = formatNumber(this.state.areaM2, 2) + ' m²';
    if (this.propertyRate) this.propertyRate.value = this.state.material + ' — £' + formatNumber(this.state.rate, 2) + ' / m² · minimum £' + formatNumber(this.state.minimum, 2);
    if (this.propertyPrice) this.propertyPrice.value = formatMoneyGBP(this.state.calculatedPrice);
    this.propertyCrop.value = [
      this.imageLabel,
      'X ' + formatNumber(crop.xPct, 2) + '%',
      'Y ' + formatNumber(crop.yPct, 2) + '%',
      'W ' + formatNumber(crop.widthPct, 2) + '%',
      'H ' + formatNumber(crop.heightPct, 2) + '%',
      'Zoom ' + Math.round(this.state.zoom * 100) + '%',
      'Rotate ' + this.state.rotation + '°',
      'Mirror ' + (this.state.mirrored ? 'Yes' : 'No')
    ].join(' | ');

    if (this.propertyData) {
      this.propertyData.value = [
        'v2',
        'img=' + this.imageId,
        'ow=' + Math.round(this.state.naturalWidth),
        'oh=' + Math.round(this.state.naturalHeight),
        'r=' + this.state.rotation,
        'm=' + (this.state.mirrored ? 1 : 0),
        'x=' + round(crop.xPct, 4),
        'y=' + round(crop.yPct, 4),
        'w=' + round(crop.widthPct, 4),
        'h=' + round(crop.heightPct, 4)
      ].join(';');
    }

    if (this.propertyPricing) {
      this.propertyPricing.value = [
        'v1',
        'material=' + this.state.material,
        'rate=' + round(this.state.rate, 2),
        'minimum=' + round(this.state.minimum, 2),
        'area=' + round(this.state.areaM2, 4),
        'total=' + round(this.state.calculatedPrice, 2)
      ].join(';');
    }

    this.updatePriceFromInputs();
    this.updateQualityWarning(crop);
  };

  MuralCropper.prototype.setMessage = function (text, type) {
    this.message.textContent = text || '';
    this.message.classList.toggle('is-error', type === 'error');
    this.message.classList.toggle('is-warning', type === 'warning');
  };

  MuralCropper.prototype.destroy = function () {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.windowResizeHandler) {
      window.removeEventListener('resize', this.windowResizeHandler);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.windowResizeHandler);
    }
    if (this.materialChangeHandler) document.removeEventListener('change', this.materialChangeHandler);
    if (this.variantChangeHandler) document.removeEventListener('variant:change', this.variantChangeHandler);
    if (this.propertyRaf) window.cancelAnimationFrame(this.propertyRaf);
    if (this.form) this.form.classList.remove('mw-cropper-pending');
    this.root._mwCropperInstance = null;
  };

  function getCroppers(scope) {
    if (!scope) return [];
    var items = [];
    if (scope.matches && scope.matches('[data-mural-cropper]')) items.push(scope);
    if (scope.querySelectorAll) {
      items = items.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-mural-cropper]')));
    }
    return items;
  }

  function init(scope) {
    getCroppers(scope || document).forEach(function (cropper) {
      new MuralCropper(cropper);
    });
  }

  function destroy(scope) {
    getCroppers(scope).forEach(function (cropper) {
      if (cropper._mwCropperInstance && typeof cropper._mwCropperInstance.destroy === 'function') {
        cropper._mwCropperInstance.destroy();
      }
    });
  }

  window.MuralWonderCropper = {
    version: '3.2.1',
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
